<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full"
      no-padding
      :loading="loading"
      :confirm-loading="confirmLoading"
      :before-close="cancel">
    <template #header>
      <span>{{modelTitle}}</span>
    </template>
    <template #content>
      <div class="content">
        <gj-alert
          v-if="isOldVersion"
          type="warning"
          :closable="false"
          show-icon
          class="gj-mb10">
          <div>经检测：您的打印控件版本不是最新版本，为了最好的打印效果，建议您下载最新版本控件(安装前请先卸载旧版本)
            <span class="gj-pointer colorBlue gj-ml5" @click="downloadPlugin">点击下载(安装完成后请刷新页面)</span>
          </div>
        </gj-alert>
        <el-form
          ref="form"
          :model="form">
          <div class="print-wapper">
            <div class="print-params">
              <div class="wid650">
                <div>
                  <div class="color333 weight600 gj-mb10">打印机</div>
                  <div class="direbet color333" v-if="noLodopPlugin">
                    <div>未检测到打印机<span class="gj-pointer colorBlue gj-ml5" @click="downloadPlugin">安装下载驱动</span></div>
                    <div>已安装<span class="gj-pointer colorBlue gj-ml5" @click="refresh"><i class="el-icon-refresh"></i>刷新</span></div>
                  </div>
                  <template v-if="!noLodopPlugin">
                    <gj-select
                      v-model="form.printer"
                      :options="printerOptions"
                      :closable="false"
                      width="100%">
                    </gj-select>
                  </template>
                </div>
                <div>
                  <div class="color666 gj-mt16b8">纸张</div>
                  <gj-select
                    v-model="form.pageType"
                    :options="pageTypeOption"
                    placeholder="请选择纸张"
                    :closable="false"
                    @change="onChangePageType"
                    width="100%">
                  </gj-select>
                </div>
                <el-row :gutter="12">
                  <el-col :span="12">
                    <div class="gj-mt16b8 color666">
                      介质大小
                      <gj-help class="gj-help">
                        最大支持100mm * 100mm
                      </gj-help>
                    </div>
                    <el-input-number
                      v-model.number="form.mediaW"
                      controls-position="right"
                      size="small"
                      :min="1"
                      :max="100"
                      style="width: 40%">
                    </el-input-number>
                    <el-input-number
                      v-model.number="form.mediaH"
                      controls-position="right"
                      size="small"
                      :min="1"
                      :max="100"
                      style="width: 40%">
                    </el-input-number>
                    <span class="appendSlot">mm</span>
                  </el-col>
                  <el-col :span="6" class="textRight">
                    <div class="gj-mt16b8 color666 textLeft" style="margin-left: 10%;">
                      条码大小
                      <gj-help class="gj-help">
                        条码大小由SKU与FNSKU生成，请确保条码大小介于介质大小之间
                      </gj-help>
                    </div>
                    <el-input-number
                      v-model.number="form.barcodeSize"
                      controls-position="right"
                      size="small"
                      :min="1"
                      @change="onInput($event)"
                      style="width: 66%">
                    </el-input-number>
                    <span class="appendSlot">mm</span>
                  </el-col>
                  <el-col :span="6"  class="textRight">
                    <div class="gj-mt16b8 color666 textLeft" style="margin-left: 10%;">
                      条码间隙
                      <gj-help class="gj-help">
                        条码间隙默认是0.26，调整间隙时，请确保条码宽度介于介质大小之间
                      </gj-help>
                    </div>
                    <el-input-number
                      v-model.number="form.barcodeSpace"
                      controls-position="right"
                      size="small"
                      :min="0.01"
                      :precision="2"
                      :step="0.01"
                      @change="onInput($event)"
                      style="width: 66%">
                    </el-input-number>
                    <span class="appendSlot">mm</span>
                  </el-col>
                </el-row>
                <el-row :gutter="12">
                  <el-col :span="6">
                    <div class="gj-mt16b8 color666">
                      字体
                    </div>
                    <el-row :gutter="4">
                      <el-col :span="12">
                        <el-input-number
                          v-model.number="form.textSize"
                          controls-position="right"
                          size="small"
                          :min="7"
                          :disabled="fontDisabled"
                          @change="onTextInput($event, 'size')"
                          style="width: 100%">
                        </el-input-number>
                        <div class="color999 gj-mt5">大小</div>
                      </el-col>
                      <el-col :span="12">
                        <el-input-number
                          v-model.number="form.letterSpacing"
                          controls-position="right"
                          size="small"
                          :min="0"
                          :disabled="fontDisabled"
                          @change="onTextInput($event, 'spacing')"
                          style="width: 100%">
                        </el-input-number>
                        <div class="color999 gj-mt5">字间距</div>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="12"  class="textRight">
                    <div class="gj-mt16b8 color666 textLeft">
                      边距
                      <gj-help class="gj-help">
                        亚马逊要求周围保留足够的空白：左右保留0.25英寸（约6.4mm），上下保留0.125英寸（约3.2mm）
                      </gj-help>
                    </div>
                    <el-row>
                      <el-col :span="6">
                        <el-input-number
                          v-model.number="form.paddingTop"
                          controls-position="right"
                          size="small"
                          :min="0"
                          style="width: 100%">
                        </el-input-number>
                        <div class="color999 gj-mt5 textLeft">上</div>
                      </el-col>
                      <el-col :span="6">
                        <el-input-number
                          v-model.number="form.paddingBottom"
                          controls-position="right"
                          size="small"
                          :min="0"
                          style="width: 100%">
                        </el-input-number>
                        <div class="color999 gj-mt5 textLeft">下</div>
                      </el-col>
                      <el-col :span="6">
                        <el-input-number
                          v-model.number="form.paddingLeft"
                          controls-position="right"
                          size="small"
                          :min="0"
                          style="width: 100%">
                        </el-input-number>
                        <div class="color999 gj-mt5 textLeft">左</div>
                      </el-col>
                      <el-col :span="6">
                        <el-input-number
                          v-model.number="form.paddingRight"
                          controls-position="right"
                          size="small"
                          :min="0"
                          style="width: 100%">
                        </el-input-number>
                        <div class="color999 gj-mt5 textLeft">右</div>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="6">
                    <div style="margin-left: 10%;">
                      <div class="gj-mt16b8 color999 textLeft">打印列数</div>
                      <el-radio-group v-model="form.printColumn" class="gj-mt8 textLeft" @change="onChange">
                        <el-radio :label="1">单排</el-radio>
                        <el-radio :label="2">双排</el-radio>
                      </el-radio-group>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div>
                <div class="color999 gj-mt16b8">打印内容设置</div>
                <el-row>
                  <el-col v-for="item in printLabelList" :key="item.id" :span="6">
                    <gj-checkbox v-if="item.type === 'text'" v-model="item.selected" :label="item.id" :key="item.id">
                      {{ item.text }}
                    </gj-checkbox>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="print-design">
              <div class="print-media-wapper">
                <div
                  class="print-media"
                  :style="{
                    width: (form.mediaW || 50) + 'mm',
                    height: (form.mediaH || 30) + 'mm',
                    padding: (form.paddingTop || 0) + 'mm ' + (form.paddingRight || 0) + 'mm ' + (form.paddingBottom || 0) + 'mm ' + (form.paddingRight || 0) + 'mm ',
                  }">
                  <div class="print-media-padding">
                    <template v-for="item in printLabelList">
                      <vue-draggable-resizable
                        v-if="item.type === 'barcode'"
                        ref="vueDraggableResizable"
                        :key="'draggable' + item.id"
                        :active="item.id === activedId"
                        :custom-id="item.id"
                        w="auto"
                        :h="conversionMmToPx(form.barcodeSize || 10)"
                        :y="item.y"
                        :z="1"
                        :resizable="false"
                        :parent="true"
                        :prevent-deactivation="true"
                        class="vdr print-item-barcode"
                        class-name-active="print-draggable-active"
                        :onDrag="onDragCallback"
                        @activated="onActivated">
                        <img ref="barcode"/>
                      </vue-draggable-resizable>
                      <vue-draggable-resizable
                        v-if="item.type === 'text' && item.selected"
                        ref="vueDraggableResizable"
                        :key="'draggable' + item.id"
                        :active="item.id === activedId"
                        :custom-id="item.id"
                        w="auto"
                        h="auto"
                        :x="item.x"
                        :y="item.y"
                        :z="2"
                        :resizable="false"
                        :parent="true"
                        :prevent-deactivation="true"
                        class-name-active="print-draggable-active"
                        :onDrag="onDragCallback"
                        @activated="onActivated">
                        <div
                          :style="{
                            fontFamily: 'Microsoft YaHei',
                            fontSize: (item.id === activedId ? form.textSize : item.size) + 'pt',
                            letterSpacing: (item.id === activedId ? form.letterSpacing : item.spacing) + 'pt',
                            color: '#000000',
                            userSelect: 'none' }">{{printLabelMap[tabType][item.id] | defaultShow}}</div>
                      </vue-draggable-resizable>
                    </template>
                  </div>
                </div>
                <div
                  v-if="form.printColumn === 2"
                  class="print-media"
                  :style="{
                    width: (form.mediaW || 50) + 'mm',
                    height: (form.mediaH || 30) + 'mm',
                    padding: (form.paddingTop || 0) + 'mm ' + (form.paddingRight || 0) + 'mm ' + (form.paddingBottom || 0) + 'mm ' + (form.paddingRight || 0) + 'mm ',
                  }">
                  <div class="print-media-padding">
                    <template v-for="item in printLabelList">
                      <vue-draggable-resizable
                        v-if="item.type === 'barcode'"
                        ref="vueDraggableResizable"
                        :key="'draggable2' + item.id"
                        :active="false"
                        :custom-id="item.id"
                        w="auto"
                        :h="conversionMmToPx(form.barcodeSize || 10)"
                        :y="item.y"
                        :z="1"
                        :draggable="false"
                        :resizable="false"
                        :parent="true"
                        class="vdr print-item-barcode">
                        <img ref="barcode2"/>
                      </vue-draggable-resizable>
                      <vue-draggable-resizable
                        v-if="item.type === 'text' && item.selected"
                        ref="vueDraggableResizable"
                        :key="'draggable2' + item.id"
                        :active="false"
                        :custom-id="item.id"
                        w="auto"
                        h="auto"
                        :x="item.x"
                        :y="item.y"
                        :z="2"
                        :draggable="false"
                        :resizable="false"
                        :parent="true">
                        <div
                          :style="{
                            fontFamily: 'Microsoft YaHei',
                            fontSize: (item.id === activedId ? form.textSize : item.size) + 'pt',
                            letterSpacing: (item.id === activedId ? form.letterSpacing : item.spacing) + 'pt',
                            color: '#000000',
                            userSelect: 'none' }">{{printLabelMap[tabType][item.id] | defaultShow}}</div>
                      </vue-draggable-resizable>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-row class="gj-mt16b8">
            <el-col :span="14" style="min-height: 20px">
              <template v-if="source === 'sku' || source === 'listing'">
                <gj-button @click="addPrintTableItem" type="primary">添加</gj-button>
                <gj-button @click="tableData = []">全部移除</gj-button>
              </template>
            </el-col>
            <el-col v-if="!fontDisabled" :span="10" class="gj-font-align-center">
              <el-radio-group v-model="form.textAlign" @change="onRadioChange">
                <el-radio label="left">居左</el-radio>
                <el-radio label="center">居中</el-radio>
                <el-radio label="right">居右</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
        </el-form>
        <gj-table
          ref="printLabelTable"
          :data="tableData"
          :columns="columns"
          :offset-height="55"
          keep-source
          :show-overflow="false"
          :edit-config="{trigger: 'click', mode: 'row', showStatus: true}"
          :show-pagination="false">
          <template v-slot:header:printCount>
            <div class="flex justify-between">
              <span class="gj-mr15">打印数量</span>
              <gj-popover
                v-model="printCountVisible"
                width="150"
                placement="top"
                trigger="click"
                @close="printCountVisible = false">
                <template slot="reference">
                  <span class="colorBlue cursor size12">一键设置</span>
                </template>
                <template>
                  <el-input-number
                    v-model="form.printCount"
                    controls-position="right"
                    :min="1"
                    style="width: 150px">
                  </el-input-number>
                  <div style="text-align: right; margin-top: 14px;">
                    <gj-button @click="printCountVisible = false">取消</gj-button>
                    <gj-button type="primary" @click="confirmPrintCount">确定</gj-button>
                  </div>
                </template>
              </gj-popover>
            </div>
          </template>
          <template v-slot:asin="{ row }">
            <div>
              <gj-tooltip :content="row.asin" :text-line="1">
                {{row.asin | defaultShow}}
              </gj-tooltip>
            </div>
            <div>
              <gj-tooltip :content="row.msku" :text-line="1">
                {{row.msku | defaultShow}}
              </gj-tooltip>
            </div>
          </template>
          <template v-slot:title="{ row }">
            <gj-tooltip :content="row.title">
              {{formatEllipsis(row.title) | defaultShow}}
            </gj-tooltip>
          </template>
          <template v-slot:titlePrint="{ index }">
            <gj-input
              type="textarea"
              v-model="tableData[index].titlePrint"
              :rows="2"
              @input="onTableInput($event, index, 'titlePrint')"
              resize="none"
              class="defaultFont"
              width="100%">
            </gj-input>
            <!-- <span v-else>{{tableData[index].titlePrint}}</span> -->
          </template>
            <template v-slot:productName="{ row }">
            <div>
              <gj-tooltip :content="row.productName" :text-line="1">
                {{row.productName | defaultShow}}
              </gj-tooltip>
            </div>
            <div>
              <gj-tooltip :content="row.sku" :text-line="1">
                {{row.sku | defaultShow}}
              </gj-tooltip>
            </div>
          </template>
          <template v-slot:name="{ row }">
            <gj-tooltip :content="row.name">
              {{formatEllipsis(row.name) | defaultShow}}
            </gj-tooltip>
          </template>
          <template v-slot:namePrint="{ index }">
            <gj-input
              type="textarea"
              v-model="tableData[index].namePrint"
              :rows="2"
              class="defaultFont"
              @input="onTableInput($event, index, 'namePrint')"
              resize="none"
              width="100%">
            </gj-input>
            <!-- <span v-else>{{tableData[index].namePrint}}</span> -->
          </template>
          <template v-slot:fnsku="{ index }">
            <div v-if="tableData[index].isUpdateFnsku">
              <gj-input
                v-model="tableData[index].fnsku"
                class="defaultFont"
                @input="onTableInput($event, index, 'fnsku')"
                width="100%">
              </gj-input>
            </div>
            <span v-else>{{tableData[index].fnsku}}</span>
          </template>
          <template v-slot:printCount="{ index }">
            <el-input-number
              v-model.number="tableData[index].printCount"
              controls-position="right"
              size="small"
              :min="1"
              @input="onTableInput($event, index, 'printCount')"
              style="width: 100%">
            </el-input-number>
          </template>
          <template v-slot:op="{ index }">
            <gj-button type="text" @click="deleteItem(index)">移除</gj-button>
          </template>
        </gj-table>
      </div>
    </template>
    <template #footer>
      <gj-button @click="cancel">关闭</gj-button>
      <gj-button type="primary" @click="printCheck">打印</gj-button>
    </template>
  </gj-modal>
</template>

<script>
import VueDraggableResizable from '../vue-draggable-resizable/vue-draggable-resizable';
import {formRuleMixin, modalMixIn} from "@/minxins";
import {isMeaningful, isMeaningless, unique} from "@/utils/common";
import { getLodop } from "./LodopFuncs.js";
import { queryCustomPrint, saveCustomPrint, getPrintSimpleListings, exportCommonFile } from "@/api/common";
import { getPrintListingLabelsInfo } from "@/api/logistics";
import { mapGetters } from 'vuex';
import { PaperLabel, PaperLabelColumnOption, BarcodeEncodeingOptoins } from '@/utils/options';
import { transformToMap } from '@/utils/common';
import { DefaultTextConfigEnum, printLabelMap, editPrintLabelMap, goodsprintLabelList, productPrintLabelList } from './config';
import JsBarcode from 'jsbarcode';
import BigNumber from 'bignumber.js';
import APPAddPrintGoods from '../add-print-goods/add-print-goods';
import AppAddProductModal from "../../modules/product/product-manager/modal/print-label/add-product-modal";

export default {
  name: "label-print-modal",
  mixins: [modalMixIn, formRuleMixin],
  components: { VueDraggableResizable },
  props: {
    modelTitle: {
      type: String,
      default: '打印商品标签'
    },
    // 打印业务来源，listing、sku、fba
    source: {
      type: String,
      required: true
    },
    // 选择数据获取方式 direct/interface 直接传递/接口获取
    mode: {
      type: String,
      default: 'direct'
    },
    items: {
      type: Array,
      required: true
    },
    // interface 接口发送获取数据入参
    params: {
      type: Object,
      default: () => {
        return null
      }
    },
    // 打印类型 GOODS/PRODUCT
    tabType: {
      type: String,
      default: 'GOODS'
    },
    // 表格columns
    columns: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      lodop: null,
      noLodopPlugin: false,
      isOldVersion: false,
      loading: false,
      confirmLoading: false,
      form: {
        printer: null,
        pageType: 11,
        mediaW: 50,
        mediaH: 30,
        barcodeSize: 10,
        barcodeSpace: 0.26,
        textSize: 10,
        letterSpacing: 0,
        paddingTop: 1,
        paddingBottom: 1,
        paddingLeft: 1,
        paddingRight: 1,
        printColumn: 1,
        textAlign: null,
        printCount: 1,
      },
      barcodeObj: {
        barcodeWidth: null,
        barcodeEncoding: "CODE128B",
        key: ''
      },
      printerOptions: [],
      activedId: null,
      fontDisabled: true,
      printLabelMap,
      printLabelList: [],
      tableData: [],
      pageTypeOption: PaperLabel,
      pageTypeOptionMap: transformToMap(PaperLabel),
      barcodeEncodeingMap: transformToMap(BarcodeEncodeingOptoins),
      taskName: '打印标签',
      printCountVisible: false
    }
  },
  computed: {
    ...mapGetters({
      marketOption: 'marketOption',
    })
  },
  watch: {
    'form.mediaW': {
      handler() {
        this.$nextTick(()=> {
          if(isMeaningful(this.$refs.vueDraggableResizable)) {
            this.$refs.vueDraggableResizable.forEach(item => item.checkSize())
          }
        })
      },
      immediate: true
    },
    'form.mediaH': {
      handler() {
        this.$nextTick(()=> {
          if(isMeaningful(this.$refs.vueDraggableResizable)) {
            this.$refs.vueDraggableResizable.forEach(item => item.checkSize())
          }
        })
      },
      immediate: true
    },
    'form.textSize': {
      handler() {
        this.$nextTick(()=> {
          if(isMeaningful(this.$refs.vueDraggableResizable)) {
            let index = this.$refs.vueDraggableResizable.findIndex(item => item.customId === this.activedId)
            if(index != -1){
              this.$refs.vueDraggableResizable[index].checkSize()
            }
          }
        })
      },
      immediate: true
    },
    'form.letterSpacing': {
      handler() {
        this.$nextTick(()=> {
          if(isMeaningful(this.$refs.vueDraggableResizable)) {
            let index = this.$refs.vueDraggableResizable.findIndex(item => item.customId === this.activedId)
            if(index != -1){
              this.$refs.vueDraggableResizable[index].checkSize()
            }
          }
        })
      },
      immediate: true
    }
  },
  created() {

    if(this.mode === 'direct') {
      this.directInit()
    } else if(this.mode === 'interface') {
      this.interfaceInit()
    }

    try {
      this.lodop = getLodop();
    } catch (err) {
      this.noLodopPlugin = true;
      console.log(err);
    }

    if (this.noLodopPlugin) {
      return;
    }
    if (this.lodop.VERSION < '6.5.0.4') {
      // 提示更新打印插件
      this.isOldVersion = true;
    }
    this.loadPrintPrams();
  },
  methods: {

    /**
     * 加载打印模型参数
     */
    loadPrintPrams() {
      // 获取系统所带的打印机
      this.getSystemPrinter();
    },

    /**
     * 获取系统的打印机设备
     */
    getSystemPrinter() {
      const systemPrinterCount = this.lodop.GET_PRINTER_COUNT();
      this.printerOptions = Array.from({length: systemPrinterCount}, (v, i) => {
          const printer = this.lodop.GET_PRINTER_NAME(i);
          return {id: i, text: printer};
      });
      if(!this.form.printer && this.printerOptions.length > 0) {
        this.form.printer = this.printerOptions[0].id
      }
    },

    // 下载驱动
    downloadPlugin() {
      exportCommonFile(`/file/attachment/download/biz?bizIds[]=CLodop_Setup_for_Win32NT_GERP&bizTypes[]=publicFile`)
    },

    // 刷新页面
    refresh() {
      location.reload();
    },

    // 直传数据初始化
    directInit() {
      this.loading = true;
      const tab = this.tabType;
      const barcodeKey = tab === 'GOODS' ? 'fnsku' : 'sku';
      this.barcodeObj.key = barcodeKey;
      let tableData = this._.cloneDeep(this.items);
      tableData.forEach(item => {
        item.id = item.id + ''
        item.isUpdateFnsku = isMeaningless(item[barcodeKey]);
        item.printCount = 1;
        if(tab === 'GOODS'){
          item.titlePrint = item.title;
        } else {
          item.namePrint = item.name;
        }
      })
      let params = {
        bizIds: tableData.map(item => item.id),
        bizTypes: [this.source, 'typeSetting']
      }
      params.bizIds.push(`${this.source}TypeSetting`)
      queryCustomPrint(params)
        .then(data => {
          if(data.length === 0) {
            this.formInit(tab, barcodeKey, tableData);
          }else {
            let queryByBiz = transformToMap(data, 'bizId');
            tableData.forEach(item => {
              for(let key in editPrintLabelMap[tab]) {
                let contentKey = editPrintLabelMap[tab][key]
                if (queryByBiz[item.id]?.content[contentKey]) {
                  item[key] = queryByBiz[item.id]?.content[contentKey]
                }
              }
            })
            let columns = queryByBiz[`${this.source}TypeSetting`].content?.columns || '';
            this.form.pageType = queryByBiz[`${this.source}TypeSetting`].content?.paper || 11;
            this.formInit(tab, barcodeKey, tableData, columns);
          }
        })
        .catch(()=> {
          this.formInit(tab, barcodeKey, tableData);
        })
        .complete(() => this.loading = false);
    },

    // 商品接口数据初始化
    interfaceInit() {
      this.loading = true;
      const tab = this.tabType;
      const barcodeKey = tab === 'GOODS' ? 'fnsku' : 'sku';
      this.barcodeObj.key = barcodeKey;
      // 获取打印排版配置信息
      let params = {
        bizIds: [`${this.source}TypeSetting`],
        bizTypes: ['typeSetting']
      }
      queryCustomPrint(params).then(data => {
        let queryByBiz = transformToMap(data, 'bizId');
        let columns = queryByBiz[`${this.source}TypeSetting`].content?.columns || '';
        this.form.pageType = queryByBiz[`${this.source}TypeSetting`].content?.paper || 11;
        if(this.source === 'listing') {
          this.getselectGoodslist(columns)
        }else {
          this.getselectFBAGoodslist(columns)
        }
      }).catch(() => {
        if(this.source === 'listing') {
          this.getselectGoodslist('')
        }else {
          this.getselectFBAGoodslist('')
        }
      })
    },

    // listing获取商品列表数据
    getselectGoodslist(columns = null) {
      const tab = this.tabType;
      const barcodeKey = tab === 'GOODS' ? 'fnsku' : 'sku';
      getPrintSimpleListings(this.params).then(data => {
        let tableData = data
        tableData.forEach(item => {
          item.isUpdateFnsku = isMeaningless(item[barcodeKey]);
          item.printCount = 1;
          if(isMeaningless(item[barcodeKey])) {
            item[barcodeKey] = item.printFnsku
          }
          if(tab === 'GOODS'){
            item.titlePrint = item.printTitle || item.title
          } else {
            item.namePrint = item.printSkuName || item.name
          }
        })
        this.formInit(tab, barcodeKey, tableData, columns)
      })
      .complete(() => this.loading = false);
    },

    // fba获取商品商品列表数据
    getselectFBAGoodslist(columns = null) {
      const tab = this.tabType;
      const barcodeKey = tab === 'GOODS' ? 'fnsku' : 'sku';
      getPrintListingLabelsInfo(this.params).then(data => {
        let tableData = data
        tableData.forEach(item => {
          item.isUpdateFnsku = isMeaningless(item[barcodeKey]);
          item.printCount = item.quantityShipped;
          item.title = item.listingTitle
          if(isMeaningless(item[barcodeKey])) {
            item[barcodeKey] = item.printFnsku
          }
          if(tab === 'GOODS'){
            item.titlePrint = item.printTitle || item.title
          } else {
            item.namePrint = item.printSkuName || item.name
          }
        })
        this.formInit(tab, barcodeKey, tableData, columns)
      })
      .complete(() => this.loading = false);
    },
    // 表单初始化
    formInit(tab, barcodeKey, tableData, columns = null) {
      let Item = tableData.length ? tableData[0]: null
      if(isMeaningful(Item)) {
        for(let key in this.printLabelMap[tab]) {
          if (isNaN(Number(key))) {
            let isFormat = ['title', 'titlePrint', 'productName', 'name', 'namePrint'].includes(key);
            if (isFormat) {
              this.printLabelMap[tab][key] = this.formatEllipsis(Item[key] || '')
            } else {
              this.printLabelMap[tab][key] = Item[key]
            }
          }
        }
      }
      this.tableData = tableData
      let columnsjson = isMeaningful(columns) ? JSON.parse(columns) : ''
      if(!Array.isArray(columnsjson) && isMeaningful(columnsjson)) {
        if(columnsjson?.printLabelLis && columnsjson.printLabelList.length > 0) {
          this.printLabelList = columnsjson.printLabelList
        }else {
          this.printLabelList = tab === 'GOODS' ? goodsprintLabelList : productPrintLabelList
        }
        if(columnsjson?.form) {
          for(let key in columnsjson.form) {
            this.form[key] = columnsjson.form[key]
          }
        }
      } else {
        this.printLabelList = tab === 'GOODS' ? goodsprintLabelList : productPrintLabelList
      }
      this.nextTick(() => {
        if(isMeaningful(this.$refs.barcode)) {
          this.createBarcode(this.$refs.barcode, this.printLabelMap[tab][barcodeKey] || '123456789')
          if (this.form.printColumn == 2) this.createBarcode(this.$refs.barcode2, this.printLabelMap[tab][barcodeKey] || '123456789')
        }
      })
    },

    // 标题字符过长格式处理
    formatEllipsis(str = '', limitlen = 45) {
      if(isMeaningful(str) && str.length > limitlen) {
        return str.substring(0, 20) + '...' + str.substring(str.length - 21, str.length)
      } else {
        return str
      }
    },

    // 创建条形码
    createBarcode(el, value) {
      JsBarcode(el, value, {
        format: "CODE128B",  //条形码的格式
        width: this.conversionMmToPx(this.form.barcodeSpace || 0.26),
        height: this.conversionMmToPx(this.form.barcodeSize || 10),  //条码高度
        displayValue: false, //是否显示文字信息
        margin: 0,
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0
      })
    },

    // 更换打印纸张
    onChangePageType(ev) {
      const { width, height } = this.pageTypeOptionMap[ev];
      this.form.mediaW = width;
      this.form.mediaH = height;
    },

    // 修改条码大小/间距
    onInput(ev) {
      let tab = this.tabType
      let barcodeKey = this.barcodeObj.key
      this.createBarcode(this.$refs.barcode, this.printLabelMap[tab][barcodeKey] || '123456789');
      if (this.form.printColumn == 2) this.createBarcode(this.$refs.barcode2, this.printLabelMap[tab][barcodeKey] || '123456789');
    },

    // 字体大小变化回调
    onTextInput(ev, type) {
      this.printLabelList.forEach((item, i) => {
        if(item.id === this.activedId) {
          this.$set(item, type, ev || (type === 'size' ? 10 : 0))
        }
      })
    },

    // 切换打印列数单排双排
    onChange(ev) {
      if(ev === 2) {
        let tab = this.tabType
        let barcodeKey = this.barcodeObj.key
        this.createBarcode(this.$refs.barcode2, this.printLabelMap[tab][barcodeKey] || '123456789')
      }
    },
    // 切换居中左右
    onRadioChange(ev) {
      let index = this.$refs.vueDraggableResizable.findIndex(item => item.customId === this.activedId)
      if(index != -1){
        this.$refs.vueDraggableResizable[index].checkSize()
        const { width, parentWidth } =  this.$refs.vueDraggableResizable[index]
        this.printLabelList.forEach((item, i) => {
        if(item.id === this.activedId) {
          if(ev === 'left') this.$set(item, 'x', 0)
          if(ev === 'center') this.$set(item, 'x', (parentWidth - width)/2)
          if(ev === 'right') this.$set(item, 'x', (parentWidth - width))
        }
      })
      }
    },
     /**
     * @description 点击选中打印内容回调
     * @param id number/String 内容ID
     * @return null
     */
    onActivated(id) {
      this.activedId = id
      this.form.textAlign = ''
      let printIndex = this.printLabelList.findIndex(item => item.id === this.activedId)
      let printItem = printIndex >= 0 ? this.printLabelList[printIndex] : null
      if (isMeaningful(printItem)) {
        this.fontDisabled = printItem.type === 'barcode'
        if (printItem.type === 'text') {
          this.form.textSize = printItem.size || 10
          this.form.letterSpacing = printItem.spacing || 0
        }
      }else {
        this.fontDisabled = true
      }
    },

    onDragCallback(x, y) {
      this.printLabelList.forEach(item => {
        if(item.id === this.activedId) {
          item.x = x
          item.y = y
        }
      })
    },

    /**
     * @description 异步组件可调整回调
     * @param callback function 回调执行方法
     */
    nextTick (callback) {
      this.$nextTick(() => {
        setTimeout(()=> {
          callback()
        }, 200)
      })
    },

    /**
     * @description 像素转换成毫米 1in = 2.54cm = 25.4 mm = 101.6q = 72pt = 6pc = 96px
     * @param px number 像素
     * @return number
     */
    conversionPxToMm(px) {
      const pxWrapper = new BigNumber(px);
      return pxWrapper.multipliedBy(25.5).div(96).toNumber();
    },

    /**
     * @description 毫米转换成像素 1in = 2.54cm = 25.4 mm = 101.6q = 72pt = 6pc = 96px
     * @param mm number 毫米
     * @return number
     */
    conversionMmToPx(mm) {
      const mmWrapper = new BigNumber(mm);
      return mmWrapper.multipliedBy(96).div(25.4).toNumber();
    },

    // 一键修改打印数量
    confirmPrintCount() {
      this.tableData.forEach(item => {item.printCount = this.form.printCount})
      this.printCountVisible = false
    },

    // 一键同步打印数量与申报数量
    syncNum () {
      this.tableData.forEach(item => {item.printCount = item.quantityShipped})
    },

    /**
     * @description table中修改的打印内容
     * @param index number 下标,
     * @param key string 打印内容key
     * @return number
     */
    onTableInput(ev, index, key) {
      if(index === 0) {
        const tab = this.tabType
        this.printLabelMap[tab][key] = ev
      }
      this.$set(this.tableData[index], key, ev)
    },

    // 添加商品/产品
    addPrintTableItem() {
      if(this.tabType === 'PRODUCT') {
        this.$gjCreate(AppAddProductModal, {
          props: {
            hideSkuList: this.tableData.map(item => item.sku),
          },
          on: {
            select: (products) => {
              this.printTableAddInit(products)
            }
          }
        });
      }else {
        this.$gjCreate(APPAddPrintGoods, {
          props: {
            hideIds: this.tableData.map(item => item.id),
            withWarehouse: this.source === 'fba'
          },
          on: {
            select: (goods) => {
              this.printTableAddInit(goods)
            }
          }
        });
      }
    },

    // 添加产品/商品数据初始化
    printTableAddInit(arr) {
      const tab = this.tabType
      const barcodeKey = tab === 'GOODS' ? 'fnsku' : 'sku'
      // arr.forEach((item) => {
      //   item.isUpdateFnsku = isMeaningless(item[barcodeKey]);
      //   item.printCount = 1;
      //   if(tab === 'GOODS'){
      //     item.titlePrint = item.title;
      //   } else {
      //     item.namePrint = item.name;
      //   }
      //   this.tableData.push(item)
      // });
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i]
        item.isUpdateFnsku = isMeaningless(item[barcodeKey]);
        item.printCount = 1;
        if(tab === 'GOODS'){
          item.titlePrint = item.title;
        } else {
          item.namePrint = item.name;
        }
        if(this.tableData.length > 50) {
          this.$gjMessage.warning('一次最多操作50条数据');
          return
        } else {
          this.tableData.push(item)
        }
      }
    },

    deleteItem(index) {
      this.tableData.splice(index, 1);
    },

    // 关闭弹框
    cancel() {
      this.$gjDestroy()
    },

    // 打印前数据校验
    printCheck() {
      if(this.noLodopPlugin) {
        this.$gjMessage.error('未检测到打印控件,请安装完成后刷新页面,进行使用');
        return
      }
      const barcodeKey = this.barcodeObj.key
      const noPrintList = this.tableData.filter(item => isMeaningless(item[barcodeKey]))
      if (this.tableData.length === 0) {
        this.$gjMessage.error('请添加打印数据!');
      }else if (noPrintList.length === this.tableData.length) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: '确认打印？',
            content: `所选择的全部商品缺失FNSKU，将无法进行打印`
          },
          on: {
            confirm: () => {
              modal.$gjDestroy();
            }
          }
        })
      } else if(noPrintList.length > 0) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: '确认打印？',
            content: `MSKU: ${noPrintList.map(item => item.msku).join('、')}商品缺失FNSKU，系统会自动过滤,确认是否打印`
          },
          on: {
            cancel: () => {
              modal.$gjDestroy();
              let index = this.tableData.findIndex(item => isMeaningless(item[barcodeKey]));
              if(index >= 0 ) {
                this.$refs.printLabelTable.$refs.gjTable.scrollTo(0, index * 56);
              }
            },
            confirm: () => {
              modal.$gjDestroy();
              this.print();
            }
          }
        })
      }else {
        this.print();
      }
    },

    // 打印
    print() {
      this.confirmLoading = true
      const { printer, pageType, mediaW, mediaH, paddingTop, paddingBottom, paddingLeft, paddingRight, printColumn } = this.form
      const { barcodeEncoding } = this.barcodeObj
      const tab = this.tabType
      const isThermalPaper = [11, 12].includes(pageType); // 是否为热敏纸
      const paddingY = paddingLeft;
      const paddingX = paddingTop;
      const page = this.pageTypeOptionMap[pageType];
      const barcodeKey = this.barcodeObj.key

      if (isThermalPaper) {
        this.lodop.PRINT_INIT(this.taskName);
        this.lodop.SET_PRINT_PAGESIZE(0, `${mediaW * printColumn}mm`, `${mediaH}mm`, '');
      } else {
        if (page.havePadding) {
          this.lodop.PRINT_INITA(`${page.paddingTop}mm`, `${page.paddingLeft}mm`, `${page.pageWidth}mm`, `${page.pageHeight}mm`, this.taskName);
        } else {
          this.lodop.PRINT_INIT(this.taskName);
          this.lodop.SET_PRINT_PAGESIZE(0, `${page.pageWidth}mm`, `${page.pageHeight}mm`, '');
        }
      }
      this.lodop.SET_PRINT_MODE('POS_BASEON_PAPER', true);
      // 2.添加打印内容
      if (isThermalPaper) {
        const printList = this.tableData.filter(item => item.printCount > 0 && isMeaningful(item[barcodeKey]))
        // 热敏纸
        printList.forEach(data => {
          this.lodop.PRINT_INIT(this.taskName);
          this.lodop.SET_PRINT_PAGESIZE(0, `${mediaW * printColumn}mm`, `${mediaH}mm`, 'CreateCustomPage');
          if (printColumn === 2) {
            if (data.printCount >= 2) {
              // this.addPrintItem(tab, data, mediaW, mediaH, barcodeEncoding, 0, 0, paddingX, paddingY, 0);
              // this.addPrintItem(tab, data, mediaW, mediaH, barcodeEncoding, 0, 1, paddingX, paddingY, 1.52);
              // this.lodop.SET_PRINT_COPIES(Math.floor(data.printCount / 2));
              // 添加打印项
              if(data.printCount % 2 === 0){
                for(let i=0; i < data.printCount; i++){
                  this.addPrintItem(tab, data, mediaW, mediaH, barcodeEncoding, 0, 0, paddingX, paddingY, 0, i);
                  ++i;
                  this.addPrintItem(tab, data, mediaW, mediaH, barcodeEncoding, 0, 1, paddingX, paddingY, 1.52, i);
                  this.lodop.NEWPAGE();
                }
              }else{
                for(let i=0; i < data.printCount - 1 ; i++){
                  this.addPrintItem(tab, data, mediaW, mediaH, barcodeEncoding, 0, 0, paddingX, paddingY, 0, i);
                  ++i;
                  this.addPrintItem(tab, data, mediaW, mediaH, barcodeEncoding, 0, 1, paddingX, paddingY, 1.52, i);
                  this.lodop.NEWPAGE();
                }
              }
            } else {
              this.addPrintItem(tab, data, mediaW, mediaH, barcodeEncoding, 0, 0, paddingX, paddingY, 0, 1);
            }
            this.lodop.SET_PRINTER_INDEX(printer);
            this.lodop.SET_PRINT_STYLE('FontName', DefaultTextConfigEnum.FONT_FAMILY);
            this.lodop.SET_PRINT_STYLE('FontColor', DefaultTextConfigEnum.COLOR);
            this.lodop.PRINT();
            if (data.printCount >= 2 && data.printCount % 2 === 1) {
              this.lodop.PRINT_INIT(this.taskName);
              this.lodop.SET_PRINT_PAGESIZE(0, `${mediaW * printColumn}mm`, `${mediaH}mm`, 'CreateCustomPage');
              this.addPrintItem(tab, data, mediaW, mediaH, barcodeEncoding, 0, 0, paddingX, paddingY, 0, data.printCount -1);
              this.lodop.SET_PRINTER_INDEX(printer);
              this.lodop.SET_PRINT_STYLE('FontName', DefaultTextConfigEnum.FONT_FAMILY);
              this.lodop.SET_PRINT_STYLE('FontColor', DefaultTextConfigEnum.COLOR);
              this.lodop.PRINT();
            }
          } else {
            // 添加打印项
            Array.from({length: data.printCount}, (_, i) => i)
              .forEach(i => {
                this.addPrintItem(tab, data, mediaW, mediaH, barcodeEncoding, 0, 0, paddingX, paddingY, 0, i);
                this.lodop.NEWPAGE();
              });
            this.lodop.SET_PRINT_COPIES(1);
            this.lodop.SET_PRINTER_INDEX(printer);
            this.lodop.SET_PRINT_STYLE('FontName', DefaultTextConfigEnum.FONT_FAMILY);
            this.lodop.SET_PRINT_STYLE('FontColor', DefaultTextConfigEnum.COLOR);
            this.lodop.PRINT();

            // this.addPrintItem(tab, data, mediaW, mediaH, barcodeEncoding, 0, 0, paddingX, paddingY, 0);
            // this.lodop.SET_PRINT_COPIES(data.printCount);
          }
        });
      } else {
        // A4类型纸张
        let row = 0,
            column = 0,
            addedCount = 0;
        const {widthCount, heightCount} = page;
        const singlePaperPrintCount = widthCount * heightCount;
        const printList = this.tableData.filter(item => item.printCount > 0 && isMeaningful(item[barcodeKey]))
        printList.forEach(data => {
          const needToAddMask = printList.length >= 2;
          if (needToAddMask && data.printCount) {
            if (addedCount >= singlePaperPrintCount && addedCount % singlePaperPrintCount === 0) {
              this.lodop.NEWPAGE();
              row = 0;
              column = 0;
            }
            if (column === widthCount) {
              column = 0;
              row++;
            }
            if (row === heightCount) {
              row = 0;
            }
            this.addPrintMask(data[barcodeKey], mediaW, mediaH, column, row);
            column++;
            addedCount++;
          }
          Array.from({length: data.printCount}, (_, i) => i)
            .forEach(i => {
              if (addedCount >= singlePaperPrintCount && addedCount % singlePaperPrintCount === 0) {
                this.lodop.NEWPAGE();
                row = 0;
                column = 0;
              }
              if (column === widthCount) {
                column = 0;
                row++;
              }
              if (row === heightCount) {
                row = 0;
              }
              const interval = page.interval ? page.interval * (column + 1) : 0;
              this.addPrintItem(tab, data, mediaW, mediaH, barcodeEncoding, row, column, paddingX, paddingY, interval, i);
              addedCount++;
              column++;
            });
        });
        this.lodop.SET_PRINTER_INDEX(printer);
        this.lodop.SET_PRINT_STYLE('FontName', DefaultTextConfigEnum.FONT_FAMILY);
        this.lodop.SET_PRINT_STYLE('FontColor', DefaultTextConfigEnum.COLOR);
        this.lodop.PRINT();
      }
      this.confirmLoading = false

      this.save();
      this.$gjDestroy();
    },

    /**
     * @description 添加打印项
     * @param data any 打印的数据对象
     * @param mediaW number 打印介质宽度
     * @param barcodeEncoding 条码编码
     * @param row number 第几列
     * @param column number 第几行
     */
    addPrintItem(tab, data, mediaW, mediaH, barcodeEncoding, row, column, paddingX, paddingY, interval, index) {
      const printLabelList = this.printLabelList.filter(item => item.selected)
      printLabelList.forEach(content => {
        // 5.1 打印条码
        if (content.type === 'barcode') {
          let barcodeKey = this.barcodeObj.key
          this.addBarcodePrintItem(content, mediaW, mediaH, data[barcodeKey], barcodeEncoding, row, column, paddingX, paddingY, interval);
        }
        // 5.2 打印文字
        if (content.type === 'text') {
          const value = Number(content.id) < 0 ? this.printLabelMap[tab][content.id] : this.valueTransform(content.id, data[content.id]);
          if((value??'') !== '') this.addTextPrintItem(content, mediaW, mediaH, value, row, column, paddingX, paddingY, interval);
        }
      });
    },


    /**
     * 添加条码打印项
     * @param barcode BarcodeConfig 条码打印配置参数
     * @param mediaW number 介质宽度
     */
    addBarcodePrintItem(barcode, mediaW, mediaH, value, format, row, column, paddingX = 0, paddingY = 0, interval = 0) {
      const y = this.conversionPxToMm(barcode.y);
      const { barcodeSize, barcodeSpace } = this.form
      const barcodeWidth = this.conversionPxToMm(this.getBarcodeWidth(value, format, this.conversionMmToPx(barcodeSpace)));
      const top = BigNumber.sum(y.toFixed(2), paddingY, new BigNumber(row).multipliedBy(mediaH)).toNumber();
      const left = BigNumber.sum((new BigNumber(mediaW).minus(barcodeWidth).div(2)), (new BigNumber(mediaW).multipliedBy(column)), interval).toNumber();
      const h = `${barcodeSize}mm`;
      this.lodop.ADD_PRINT_BARCODE(`${top}mm`, `${left}mm`, `${barcodeWidth}mm`, h, this.barcodeEncodeingMap[format].printCode, value);
      this.lodop.SET_PRINT_STYLEA(0, 'ShowBarText', false);
    },

    /**
     * 添加文字打印项
     * @param text TextConfig 文字打印配置参数
     * @param mediaW number 介质宽度
     */
    addTextPrintItem(textItem, mediaW, mediaH, value, row, column, paddingX = 0, paddingY = 0, interval = 0) {
      let {y, x, size, spacing} = textItem;
      x = this.conversionPxToMm(x);
      y = this.conversionPxToMm(y);
      const top = BigNumber.sum(y.toFixed(2), paddingY, new BigNumber(row).multipliedBy(mediaH)).toNumber();
      const left = BigNumber.sum(BigNumber.sum(x.toFixed(2), paddingX, new BigNumber(column).multipliedBy(mediaW)), interval).toNumber();
      this.lodop.SET_PRINT_STYLE('FontSize', size);
      this.lodop.SET_PRINT_STYLE('FontName', 'Microsoft YaHei');
      this.lodop.SET_PRINT_STYLE('Alignment', 1);
      const width = new BigNumber(mediaW).minus(new BigNumber(paddingX).multipliedBy(2)).toNumber();
      // const width = new BigNumber(mediaW).minus(new BigNumber(paddingX)).toNumber();
      this.lodop.ADD_PRINT_TEXT(`${top}mm`, `${left}mm`, `${width}mm`, `${size}mm`, value);
      this.lodop.SET_PRINT_STYLEA(0, 'LetterSpacing', spacing || 0 + 'pt');
    },

    addPrintMask(value, mediaW, mediaH, column, row, interval = 0) {
      value = value || '';
      const fontSize = 14;
      this.lodop.SET_PRINT_STYLE('FontSize', fontSize);
      this.lodop.SET_PRINT_STYLE('FontName', 'Microsoft YaHei');
      this.lodop.SET_PRINT_STYLE('Alignment', 2);
      const top = (mediaH - fontSize) / 2 + row * mediaH;
      const left = 5 + column * mediaW + interval;
      const width = (column + 1) * mediaW - left + 2;
      this.lodop.ADD_PRINT_TEXT(`${top}mm`, `${left}mm`, `${width}mm`, `${fontSize * 2}pt`, value);
    },

    // 打印内容转换
    valueTransform(key, content) {
      let isFormat = ['title', 'titlePrint', 'productName', 'name', 'namePrint'].includes(key);
      if(isFormat) {
        return this.formatEllipsis(content)
      }else {
        return content
      }
    },

    /**
     * @description 动态获取每个条形码的宽度
     * @param value string 条码生成的值
     * @param format string 条码编码
     * @param width number 条码每条线的细粒度
     * @return number 返回生成条码的总长度
     */
    getBarcodeWidth(value, format = 'CODE128B', width) {
        const el = document.createElement('img');
        const barcodeObj = JsBarcode(el, value, {
            format,
            width,
            displayValue: false,
            margin: 0,
            marginTop: 0,
            marginLeft: 0,
            marginRight: 0
        });
        return barcodeObj._encodings[0][0].width;
    },

    // 记录用户本次操作缓存
    save() {
      const tab = this.tabType
      let arr = []
      this.tableData.forEach(item => {
        let obj = {
          bizId: this.source === 'fba' ? item.shipmentId + item.msku : item.id + '',
          bizType: this.source,
          content: {}
        }
        for(let key in editPrintLabelMap[tab]) {
          let contentKey = editPrintLabelMap[tab][key]
          obj.content[contentKey] = item[key]
        }
        arr.push(obj)
      })
      let { pageType, mediaW, mediaH, barcodeSize, barcodeSpace, paddingTop, paddingBottom, paddingLeft, paddingRight } = this.form
      let columns = {
        form: {
          mediaW,
          mediaH,
          barcodeSize,
          barcodeSpace,
          paddingTop,
          paddingBottom,
          paddingLeft,
          paddingRight
        },
        printLabelList: this.printLabelList
      }
      arr.push({
        bizId: `${this.source}TypeSetting`,
        bizType: 'typeSetting',
        content: {
          columns: JSON.stringify(columns),
          paper: pageType
        }
      })
      saveCustomPrint(arr)
    }
  }
}
</script>

<style scoped lang="scss">
  .content {
    padding: 15px 20px 0 20px;
    word-wrap: break-word;
    white-space: normal;
    .print-wapper {
      display: flex;
      .print-params {
        flex: 1;
        .wid650 {
          width: 650px;
        }
        /deep/ .el-input-number.is-controls-right .el-input__inner {
          padding-left: 10px;
          padding-right: 30px;
        }
        /deep/ .el-input-number--small .el-input-number__increase{
          width: 20px;
          display: none;
        }
        /deep/ .el-input-number--small .el-input-number__decrease {
          width: 20px;
          display: none;
        }
        /deep/ .el-input-number--small:hover {
          .el-input-number__increase{
            display: block;
          }
          .el-input-number__decrease {
            display: block;
          }
        }
        .appendSlot {
          display: inline-block;
          box-sizing: border-box;
          color: #666666;
          background: #EEEFF0;
          min-width: 30px;
          padding: 5px;
          text-align: center;
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
          height: 32px;
          border: 1px solid #DCDFE6;
          border-left: none;
          font-size: 13px;
        }
      }
      .print-design {
        flex: 0 0 455px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        row-gap: 8px;
        position: relative;
      }
    }
    .cursor {
      cursor:pointer
    }
    .gj-mr15 {
      margin-right: 15px;
    }
    .direbet {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
    }
    .defaultFont {
      font-family: Verdana, PingFangSC-Regular, PingFang SC, -apple-system, BlinkMacSystemFont, Segoe UI, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
    }
    /deep/ .borlnone {
      .el-input__inner {
        border-left: none;
      }
    }
    /deep/ .el-form-item {
      margin-bottom: 10px;
    }
    .textLeft {
      text-align: left;
    }
    .textRight {
      text-align: right;
    }
    .gj-mt16b8 {
      margin-top: 16px;
      margin-bottom: 8px;
    }
    .gj-mt8 {
      margin-top: 8px;
    }
    .gj-mt5 {
      margin-top: 5px;
    }
    .print-design {
      width: 100%;
      .print-media-wapper {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        -moz-column-gap: 1px;
        column-gap: 1px;
        background-color: #EEE;
        .print-media {
          background: #FFFFFF;
          box-sizing: border-box;
          .print-media-padding {
            width: 100%;
            height: 100%;
            position: relative;
          }
          .print-item-barcode {
            width: 100%;
            position: relative;
            display: flex;
            justify-content: center;
          }
          .print-draggable-active {
            background-color: rgba(0,110,255,.1);
          }
        }
      }
    }
  }
</style>